import React, { useState, useContext } from 'react';
import { EKAnalysGroupingModeType } from '../EkonomiskAnalysFavoriteAnalysDialog';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import { IStartAnalysInfo } from '../Queries/ChangeStartAnalysMutation/ChangeStartAnalysMutation';
import { ISelection } from '../../../../../../Queries/EkonomiskAnalysInitQuery/EkonomiskAnalysInitQuery';
import EkonomiskAnalysFavoriteOptionsMenu, {
  IKombKodbehVisibility,
  IUpdateKombKodbehVisibiltyFnType,
} from '../../FavoriteAnalysDialog/Components/EkonomiskAnalysFavoriteOptionsMenu';
import { EkonomiskAnalysContext } from '../../../../../Context/EkonomiskAnalysContext';
import EDIconButton from '../../../../../../../../../../../BaseComponents/Buttons/IconButton/EDIconButton';
import SearchBar from '../../../../../../../../../../../Components/SearchBar/Components/SearchBar/SearchBar';
import { AvenyThemeDark } from '../../../../../../../../../../../BaseComponents/ThemeProvider/AvenyTheme';

interface IProps {
  groupingMode: EKAnalysGroupingModeType;
  categories: string[];
  onGroupingModeChange: (newValue: EKAnalysGroupingModeType) => void;
  searchValue: string;
  setSearchValue: (newValue: string) => void;
  showUseNewReportAsStart: boolean;
  startAnalys?: IStartAnalysInfo;
  updateStartAnalys: (analysInfo?: IStartAnalysInfo) => void;
  availableKodbeh: ISelection[];
  kombKodbehVisibility: IKombKodbehVisibility;
  updateKombKodbehVisibility: IUpdateKombKodbehVisibiltyFnType;
  updateStartAnalysAtLogin: boolean;
  setUpdateStartAnalysAtLogin: (update: boolean) => void;
}

const useStyles = makeStyles<void, 'labelFocused'>()(
  (theme, _params, classes) => ({
    input: {
      color: theme.customProperties.Fade.LightOnDark.highEmphasis,
    },
    underline: {
      '&:before': {
        borderBottomColor: theme.customProperties.Fade.LightOnDark.lowEmphasis,
      },
      '&:after': {
        borderBottomColor: theme.customProperties.Fade.LightOnDark.highEmphasis,
      },
      '&:hover:before': {
        borderBottomColor: `${theme.customProperties.Fade.LightOnDark.mediumEmphasis} !important`,
      },
    },
    label: {
      color: theme.customProperties.Fade.LightOnDark.mediumEmphasis,
      [`&.${classes.labelFocused}`]: {
        color: theme.customProperties.Fade.LightOnDark.highEmphasis,
      },
    },
    labelFocused: {
      color: theme.customProperties.Fade.LightOnDark.highEmphasis,
    },
    searchLabelFocused: {
      color: `${theme.customProperties.Fade.LightOnDark.highEmphasis} !important`,
    },
    icon: { color: theme.customProperties.Fade.LightOnDark.highEmphasis },
    toolsContainerInner: {
      display: 'flex',
      alignItems: 'flex-end',
      margin: '16px 8px 8px 0',
    },
    toolsContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
    },
    selectSearchField: {
      marginRight: theme.spacing(2),
    },
    searchInput: {
      maxWidth: 138,
    },
    whiteHeader: {
      color: theme.customProperties.Fade.LightOnDark.highEmphasis,
    },
    newReportAsStartContainer: {
      display: 'flex',
      alignItems: 'baseline',
      alignSelf: 'flex-end',
    },
    textColor: {
      color: theme.customProperties.Fade.LightOnDark.mediumEmphasis,
    },
    functionMenu: {
      position: 'absolute',
      top: '36px',
      right: '0px',
    },
    searchContainer: {
      marginRight: 16,
    },
  })
);

const EkonomiskAnalysFavoriteToolbar: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const { classes } = useStyles();
  const [optionsMenuAnchorEl, setOptionsMenuAnchorEl] =
    useState<HTMLElement | null>(null);

  const onUserMenuButtonClick = (event: React.MouseEvent<HTMLElement>) => {
    setOptionsMenuAnchorEl(event.currentTarget);
  };

  const { codeSystemId, dbName } = useContext(EkonomiskAnalysContext);

  return (
    <>
      <div className={classes.toolsContainer}>
        <div className={classes.toolsContainerInner}>
          <div className={classes.searchContainer}>
            <StyledEngineProvider injectFirst>
              <ThemeProvider theme={AvenyThemeDark}>
                <SearchBar
                  value={props.searchValue}
                  onChange={props.setSearchValue}
                />
              </ThemeProvider>
            </StyledEngineProvider>
          </div>
          <EDIconButton
            className={classes.functionMenu}
            color="inherit"
            icon="more_vert"
            tooltip="Alternativ"
            onClick={onUserMenuButtonClick}
            iconSize="medium"
            padding="medium"
            primaryBackground
          />
        </div>
        <EkonomiskAnalysFavoriteOptionsMenu
          open={Boolean(optionsMenuAnchorEl)}
          onClose={() => setOptionsMenuAnchorEl(null)}
          groupingMode={props.groupingMode}
          onGroupingModeChange={props.onGroupingModeChange}
          anchorEl={optionsMenuAnchorEl ?? undefined}
          showUseNewReportAsStart={props.showUseNewReportAsStart}
          availableKodbeh={props.availableKodbeh}
          codesystemId={codeSystemId}
          dbname={dbName}
          updateStartAnalys={props.updateStartAnalys}
          startAnalys={props.startAnalys}
          kombKodbehVisibility={props.kombKodbehVisibility}
          updateKombKodbehVisibility={props.updateKombKodbehVisibility}
          updateStartAnalysAtLogin={props.updateStartAnalysAtLogin}
          setUpdateStartAnalysAtLogin={props.setUpdateStartAnalysAtLogin}
        />
      </div>
    </>
  );
};

export default EkonomiskAnalysFavoriteToolbar;
